module.exports = __webpack_public_path__ + "img/KinokoTable19.1284ff79.jpg";